import React from 'react';
import {SvgIcon, SvgIconProps} from '@mui/material';

interface CustomCheckboxIconProps extends SvgIconProps {
  isChecked?: boolean;
  isIndeterminate?: boolean;
  isAllSelected?: boolean;
  iconSize?: number;
  isDisabled?: boolean;
  borderRadius?: number;
  dataTestId: string;
}

const CustomCheckboxIcon: React.FC<CustomCheckboxIconProps> = ({
  isChecked = false,
  isIndeterminate = false,
  isAllSelected = false,
  iconSize,
  isDisabled = false,
  borderRadius = 4,
  dataTestId = '',
  ...props
}) => {
  const iconFill = isDisabled ? '#898E97' : '#FFFFFF';
  return (
    <SvgIcon
      component="svg"
      data-testid={`custom-svg-${dataTestId}`}
      viewBox="0 0 24 24"
      sx={{
        // fontSize: `${iconSize}px`,
        height: `${iconSize}rem !important`,
        width: `${iconSize}rem !important`,
      }}
      {...props}
    >
      {/* Base rectangle with border and dynamic fill */}
      <rect
        x="1"
        y="1"
        width="22"
        height="22"
        rx={borderRadius}
        fill={isChecked ? 'currentColor' : 'transparent'}
        stroke="currentColor"
        strokeWidth="2"
        data-testid={`custom-checkbox-icon-rect-${dataTestId}`}
      />
      {/* ✓ Tick Icon (Checked) */}
      {isChecked && !isIndeterminate && !isAllSelected && (
        <g
          transform="translate(5.99, 7.58)"
          opacity="1"
          data-testid={`custom-checkbox-icon-g-${dataTestId}`}
        >
          <path
            d="M3 5.84L0.59 3.41 0 4 3 7 9 0 8.41 -0.59z"
            fill={iconFill}
            transform="scale(1.33, 1.31)"
            /* Added stroke to thicken the tick */
            stroke={iconFill}
            stroke-width="1.2"
            stroke-linejoin="round"
            stroke-linecap="round"
            data-testid={`custom-checkbox-icon-path-${dataTestId}`}
          />
        </g>
      )}
      {/* – Indeterminate Icon */}
      {isChecked && isIndeterminate && !isAllSelected && (
        <g
          transform="translate(7, 11)"
          opacity="1"
          data-testid={`custom-checkbox-icon-g-btn-${dataTestId}`}
        >
          <rect
            width="10"
            height="2"
            rx="1"
            fill={iconFill}
            data-testid={`custom-checkbox-icon-rect-btn-${dataTestId}`}
          />
        </g>
      )}
      {/* + Select All Icon */}
      {isChecked && isAllSelected && (
        <>
          {/* Horizontal line */}
          <g
            transform="translate(7, 11)"
            opacity="1"
            data-testid={`custom-checkbox-icon-g-button-${dataTestId}`}
          >
            <rect
              width="10"
              height="2"
              rx="1"
              fill={iconFill}
              data-testid={`custom-checkbox-icon-rect-button-${dataTestId}`}
            />
          </g>
          {/* Vertical line */}
          <g
            transform="translate(11, 7)"
            opacity="1"
            data-testid={`custom-checkbox-icon-g-icon-${dataTestId}`}
          >
            <rect
              width="2"
              height="10"
              rx="1"
              fill={iconFill}
              data-testid={`custom-checkbox-icon-rect-icon-${dataTestId}`}
            />
          </g>
        </>
      )}
    </SvgIcon>
  );
};

export default CustomCheckboxIcon;
